module.exports = __webpack_public_path__ + "static/media/foto.ce6b16e0.jpg";